import {isToday} from 'date-fns';
import format from 'date-fns/format';
import ruLocale from 'date-fns/locale/ru';
import React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text';

interface DayChipProps {
  date: Date | number | undefined;
}

const arePropsEqual = (prevProps: DayChipProps, nextProps: DayChipProps) => {
  return prevProps.date === nextProps.date;
};

export const DayChip = React.memo(function DayChip({date}: DayChipProps) {
  const styles = useStyles(() => ({
    container: {
      minWidth: 117,
      backgroundColor: '#ffffff60',
      alignItems: 'center',
      alignSelf: 'center',
      borderRadius: 57,
      marginBottom: 12,
      marginTop: 32,
    },
    chipText: {
      fontSize: 12,
      lineHeight: 22,
      color: '#5B6F7B',
    },
  }));

  if (!date) return null;

  const label = isToday(date) ? 'Сегодня' : format(new Date(date), 'd MMMM', {locale: ruLocale});

  return (
    <View style={styles.container}>
      <Text style={styles.chipText}>{label}</Text>
    </View>
  );
}, arePropsEqual);
